import KnowledgeGrpManagement from "Components/_PageComponents/KnowledgeGrpManagement/KnowledgeGrpManagement";
import { defaultProps } from "Components/_PageComponents/KnowledgeGrpManagement/defaultProps";

export default function GPTQAKnowledgeGrpManagement() {
  return <KnowledgeGrpManagement {...defaultProps} />;
}
